import { render, staticRenderFns } from "./EditDrawer.vue?vue&type=template&id=b195643c"
import script from "./EditDrawer.vue?vue&type=script&lang=js"
export * from "./EditDrawer.vue?vue&type=script&lang=js"
import style0 from "./EditDrawer.vue?vue&type=style&index=0&id=b195643c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports